<template>
  <div>
    <sidebar-item
      :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name:'broker.dashboard'}
          }"
    >
    </sidebar-item>
  </div>
</template>

<script>
    export default {
        name: "Sidebar"
    }
</script>

<style scoped>

</style>
